<template>
  <div>
  <L1 :style="{zIndex: 10}" :popup0="!!selected" :popup="tables">
    <template slot="slot_title">
      <Select :defaultValue="area" @input="area=$event" :width="'265px'">
        <option :value="null" disabled>全部區域</option>
        <option v-for="(rest, r) in restaurants" :key="`rest-${r}`" :value="rest" >{{rest}}</option>
      </Select>
      <DateSelect :defaultValue="range" @input="range=$event"/>
      <div :style="{marginInline:'auto'}"/>
      <RoundBtn @click="getRows" :icon="'sync'" :text="'刷新'" :bg="'var(--color-pri)'"/>
      <a class="roundBtn" :href="`webapi/restaurant/online/excel/${area}?${params}`" target="__blank"><div></div>匯出</a>
    </template>
    <LT>
      <template slot="filter">
      <Select :defaultValue="typeSelect" @input="typeSelect=$event" :width="'130px'">
        <option :value="null">類型</option>
        <option v-for="(rest, r) in types" :key="`type-${r}`" :value="rest" >{{rest}}</option>
      </Select>
      <Select :defaultValue="statusSelect" @input="statusSelect=$event" :width="'165px'">
        <option :value="null">狀態</option>
        <option v-for="(rest, r) in statusList" :key="`status-${r}`" :value="rest" >{{rest}}</option>
        <option :value="'已付款'">已付款</option>
      </Select>
      <Select :defaultValue="paymentTypeSelect" @input="paymentTypeSelect=$event" :width="'165px'">
        <option :value="null">付款方式</option>
        <option v-for="(rest, r) in ['LINE PAY', '信用卡']" :key="`pay-${r}`" :value="rest" >{{rest}}</option>
      </Select>
      <Select :defaultValue="invoiced" @input="invoiced=$event" :width="'165px'">
        <option :value="null">發票</option>
        <option :value="true">已開發票</option>
        <option :value="false">未開發票</option>
      </Select>
      <Search :defaultValue="searchText" @input="searchText=$event" :width="'530px'" :placeholder="'請輸入訂購人|電話|序號|付款編號'"/>
      <div :style="{marginInline:'auto'}"/>
      <button :style="{height: '45px'}" class="InvalidInv" @click="getRows">刷新</button>
      </template>
      <Table :rows="rows">
        <template slot="slot_head">
          <th :style="{width: '5.5em'}">付款時間</th>
          <th :style="{textAlign:'center', width: '72px'}">狀態</th>
          <th :style="{textAlign:'center', width: '72px'}">類型</th>
          <th :style="{width: '6em'}">出貨日期</th>
          <!-- <th :style="{width: '4em'}">取貨時間</th> -->
          <th>訂購人</th>
          <th :style="{width: '10em'}">訂單序號 | 付款編號</th>
          <th :style="{width: '10em'}">支付方式 | 金額</th>
          <th>發票(載具|統編)</th>
          <th :style="{width: '3em'}">退款</th>
          <!-- <th :style="{width: '3em'}">關帳</th> -->
          <!-- <th :style="{width: '4.5em'}">作廢</th> -->
        </template>
        <tr slot-scope="{item:{_id,
        invoiceCarrierNum, invoiceCustomerIdentifier, type, status, invoiceLoveCode,
        reconciledTime, visitDate, orderer, ordererTel, onlineOrderID, Inv, remitCancelTime,
        remitInfo:{remitType, Trans_Amount, transactionId, TradeNo, refundList, ecRefund, CloseData}
        }, index}">
          <td v-html="moment(reconciledTime).format('YYYY-MM-DD<br>HH:mm')"></td>
          <td><div class="status" :style="{backgroundColor: `var(--${status})`, color: '#FFFFFF'}">{{status}}</div></td>
          <td><div class="type" :style="{backgroundColor: `var(--${type})`, color: '#FFFFFF'}">{{type}}</div></td>
          <td>{{toDate(visitDate)}}</td>
          <!-- <td>{{visitTime}}</td> -->
          <td>{{orderer}}<br>{{ordererTel}}</td>
          <td v-if="remitType==='LINE PAY'">{{onlineOrderID}}<br>付:{{transactionId}} <span v-if="refundList&&refundList[0]&&refundList[0].refundTransactionId"><br>退:{{refundList[0].refundTransactionId}}</span></td>
          <td v-else>{{onlineOrderID}}<br>付:{{TradeNo}} <span v-if="ecRefund&&ecRefund.Status==='Cancelled'"><br>退:{{ecRefund&&ecRefund.TradeID}}</span></td>
          <td v-if="remitType==='LINE PAY'">
            <div class="paymentInfo">
              <button class="linePay" :id="transactionId"/>
              <span :style="{textDecoration: ((refundList||[]).length>0) ? 'line-through' : 'unset'}">{{formatDollarInt(Trans_Amount)}}</span>
            </div>
            <template  v-if="remitType==='LINE PAY'">
              <div :style="{fontSize: '14px'}" v-for="(rfd, r) in refundList" :key="`rfd-${r}`">已於{{moment(rfd.refundTransactionDate).format('YYYY-MM-DD HH:mm')}}退款 {{formatDollarInt(rfd.refundAmount)}}</div>
            </template>
          </td>
          <td v-else>
            <div class="paymentInfo">
              <button class="ecPay"/>
              <span :style="{textDecoration: (ecRefund&&ecRefund.Status==='Cancelled') ? 'line-through' : 'unset'}">{{formatDollarInt(Trans_Amount)}}</span>
            </div>
            <div :style="{fontSize: '14px'}" v-if="(CloseData&&CloseData.slice(-1)[0]&&0>CloseData.slice(-1)[0].Amount)">[退刷][{{moment(CloseData.slice(-1)[0].DateTime, 'YYYY/MM/DD+HH:mm:ss').format('YYYY-MM-DD HH:mm')}}]{{CloseData.slice(-1)[0].Amount}}元</div>
            <div :style="{fontSize: '14px'}" v-else-if="ecRefund?.status">[{{ecRefund?.status}}] <span v-if="remitCancelTime">{{moment(remitCancelTime).format('YYYY-MM-DD HH:mm')}}</span></div>
          </td>
          <td>
            <span v-for="invoice in Inv" :key="`${_id}-${invoice.InvoiceNo}`" :style="invoice.status!=='開立' ? {textDecoration:'line-through'} : {}">{{invoice.InvoiceNo}}</span>
            <span v-if="invoiceCarrierNum||invoiceCustomerIdentifier||invoiceLoveCode"><br>({{invoiceCarrierNum||invoiceCustomerIdentifier||invoiceLoveCode}})</span>
          </td>
          <td>
            <!-- &&!refundTransactionId||refundStatus -->
            <button class="refund" v-if="remitType==='LINE PAY'&&!((refundList||[]).length>0)" @click="getlinePay(_id, index)">交易<br>退款</button>
            <button class="refund" :style="{backgroundColor:'#CACACA'}" v-else-if="remitType==='LINE PAY'" @click="getlinePay(_id, index)">查詢<br>明細</button>
            <button class="refund" v-if="remitType==='信用卡'&&!(ecRefund&&ecRefund.Status==='Cancelled')&&!(CloseData&&CloseData.slice(-1)[0]&&0>CloseData.slice(-1)[0].Amount)" @click="getEcPay(_id, index)">交易<br>退款</button>
            <button class="refund" :style="{backgroundColor:'#CACACA'}" v-else-if="remitType==='信用卡'" @click="getEcPay(_id, index)">查詢<br>明細</button>
          </td>
          <!-- <td>
            <button class="refund" v-if="remitType==='信用卡'&&!(['Cancelled', 'Operation+canceled', 'To+be+captured', 'Captured'].includes(ecRefund&&ecRefund.Status))" @click="closeEcPay(_id, index)">關帳</button>
          </td> -->
          <!-- <td><button class="InvalidInv" v-if="paidTime&&!cancelTime">發票<br>作廢</button></td> -->
        </tr>
      </Table>
    </LT>
  </L1>
  <DialogVue :show="cancelEc" v-if="cancelEc" label="綠界交易資訊" @close="cancelEc=null">
    <DialogEC :data="cancelEc.data" @close="cancelEc=null" @refund="refundEcPay()" :waiting="waiting"/>
    </DialogVue>
  <DialogVue :show="cancelEcError" v-if="cancelEcError" label="[異常]綠界訊息" @close="cancelEcError=null" :haadBg="'var(--highlight)'">
    <div class="cancelEcError">{{cancelEcError}}</div>
    </DialogVue>
  <DialogVue :show="cancelLine" v-if="cancelLine" label="LINEPAY交易資訊" @close="cancelLine=null">
    <DialogLY :data="(cancelLine?.data || [])[0] || null" :transactionId="cancelLine.transactionId" :error="cancelLine.codeMsg" @close="cancelLine=null" @refund="refundLinePay"
    :waiting="waiting"/>
    </DialogVue>
  </div>
</template>

<script>
import RoundBtn from '../../components/btn/round.vue'
import DialogLY from './dialog/lyinfo.vue'
import DialogEC from './dialog/ecinfo.vue'
import DialogVue from '../../components/dialognoPadding2.vue'
import Table from '../../components/tables/t2.vue'
import Search from '../../components/input/search.vue'
import Select from '../../components/select.vue'
import DateSelect from '../../components/radio/sevenday_today_range.vue'
import L1 from '../../components/layout/L1.vue'
import LT from '../../components/layout/LaTable.vue'
import { mapState, mapGetters } from 'vuex'
import { getapi, postapi } from '../../store/fetch'
const api = 'webapi'
const BaseUrl = process.env.VUE_APP_BASE_URL + '/'
export default {
  components: { L1, DateSelect, Select, Search, Table, DialogVue, DialogEC, DialogLY, LT, RoundBtn },
  data () {
    return {
      waiting: false,
      area: null,
      tables: false,
      folded: '總計',
      range: {
        start: this.moment().add(-6, 'day').format('yyyy-MM-DD'),
        duration: 6,
        end: this.moment().format('yyyy-MM-DD')
      },
      searchText: null,
      rows: [],
      typeSelect: null,
      statusSelect: null,

      paymentTypeSelect: null,
      cancelEc: null,
      cancelLine: null,
      invoiced: null,
      cancelEcError: null
    }
  },
  computed: {
    ...mapState({
      restaurants: 'restaurants',
      defaultStore: 'defaultStore',
      typeList: 'typeList'
    }),
    statusList () {
      return this.getStatusList()(this.area)
    },
    storeType () {
      return this.getStoreType()(this.area)
    },
    types () {
      return this.typeList[this.storeType]
    },
    params () {
      const params = {
        date: this.moment(this.range.start).startOf('day').toISOString(),
        duration: this.moment(this.range.end).diff(this.range.start, 'day')
      }
      if (this.invoiced !== null) params.invoiced = this.invoiced
      if (this.statusSelect) params.status = this.statusSelect
      if (this.searchText) params.search = this.searchText
      if (this.typeSelect) params.type = this.typeSelect
      if (this.paymentTypeSelect) params.payMethod = this.paymentTypeSelect
      return new URLSearchParams(params)
    }
  },
  async mounted () {
    this.area = this.defaultStore || this.restaurants[0]
    await this.getRows()
  },
  watch: {
    async statusSelect () {
      await this.getRows()
    },
    async invoiced () {
      await this.getRows()
    },
    async searchText () {
      await this.getRows()
    },
    async typeSelect () {
      await this.getRows()
    },
    async paymentTypeSelect () {
      await this.getRows()
    },
    async area () {
      await this.getRows()
    },
    range: {
      deep: true,
      async handler () {
        if (this.range.start && this.range.end) {
          await this.getRows()
        }
      }
    }
  },
  methods: {
    wait (timeout) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(true)
        }, timeout)
      })
    },
    ...mapGetters({
      getStoreType: 'getStoreType',
      getStatusList: 'getStatusList'
    }),
    async getlinePay (id, index) {
      const r = await getapi(`payment/linepay/${id}`)
      if (r) {
        this.cancelLine = { id, index, ...r }
      }
    },
    async closeEcPay (id) {
      await postapi(`payment/ecpay/close/${id}`)
      await getapi(`payment/ecpay/${id}`)
      await this.getRows()
    },
    async getEcPay (id, index) {
      const r = await getapi(`payment/ecpay/${id}`)
      if (r) {
        this.cancelEc = { id, index, ...r }
        if (r.refresh) this.getRows()
      }
    },
    async refundLinePay () {
      this.waiting = true
      await this.wait(300)
      const { id, index } = this.cancelLine
      await fetch(`${BaseUrl}${api}/payment/linepay/refund/${id}`, { method: 'POST', headers: new Headers({ 'Content-Type': 'application/json' }) })
        .then(async (resp) => {
          const r = await resp.json()
          if (resp.status === 200) {
            this.cancelLine.codeMsg = r.codeMsg
            this.rows[index].remitInfo = r.remitInfo
            this.rows[index].status = r.status
            this.cancelLine = null
            await this.getRows()
          } else if (r.codeMsg) {
            this.cancelLine.codeMsg = r.codeMsg
          }
        })
      this.waiting = false
    },
    async refundEcPay () {
      this.waiting = true
      await this.wait(300)
      const { id, index } = this.cancelEc
      await fetch(`${BaseUrl}${api}/payment/ecpay/refund/${id}`, { method: 'POST', headers: new Headers({ 'Content-Type': 'application/json' }) })
        .then(async (resp) => {
          const r = await resp.json()
          if (resp.status === 200) {
            console.log('[refundEcPay]', r, index)
            this.rows[index].remitInfo = r.remitInfo
            this.rows[index].status = r.status
            this.cancelEc = null
            await this.getRows()
          } else if (resp.status === 400 && (r && r.Msg)) {
            this.cancelEcError = r.Msg
          }
        })
      this.waiting = false
    },
    async getRows () {
      const r = await getapi(`restaurant/online/${this.area}?${this.params}`)
      this.rows = r
    }
  }
}
</script>

<style lang="scss" scoped>
.cancelEcError {
  padding: 30px 40px 40px;
  font-size: 24px;
  letter-spacing: .1em;
}
.roundBtn {
  width: 130px;
  background-color: var(--color-pri);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  font-size: 20px;
  text-decoration: none;
  color: #FFFFFF;
  gap: 10px;
  border-radius: 25px;
  letter-spacing: .1em;
  &>div{
    background-color: #FFFFFF;
    width: 30px;
    height: 30px;
    mask-image: url(/svg/btn/excel1.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }
}
.paymentInfo {
  display: flex;
  align-items:center;
  gap: 20px
}
.InvalidInv, .refund {
  padding: 5px 10px;
  border-radius: 3px;
  background-color: var(--color-pri);
  color: #FFFFFF;
  letter-spacing: .05em;
}
.refund {
  height: 67.6px;
}
.linePay {
  background-image: url(png/linepayIcon.png);
  width: 70px;
  height: 30px;
  background-color: #FFFFFF;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.ecPay {
  background-image: url(png/ecpay.png);
  width: 70px;
  height: 22px;
  background-color: #FFFFFF;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.type, .status {
  width: 70px;
  height: 40px;
  color: #FFFFFF;
  display: flex;
  align-items:center;
  justify-content: center;
  border-radius: 20px;
  margin-inline: auto;
}
.status {
  width: 90px;
}
td, th {
  text-align:start;
}
</style>
